import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncVerifyParishionerRegistration({ ...rest }) {
  const AsyncLoad = loadable(() =>
    import("../page/verifyParishionerRegistration")
  );
  console.log("Loading", AsyncVerifyParishionerRegistration.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncVerifyParishionerRegistration;
